<!-- Center canvas: summary, text typed into directly - whole card is one pinnable region -->
<div class="cr-xe-card" *ngIf="isPreview" [id]="block.blockId">
  <span class="cr-xe-badge">Inspiration + Big Headline + 2x Photo</span>

  <span
    class="cr-xe-paragraph"
    [appInlineEdit]="block.variables?.X2ExpParagraph ?? ''"
    [inlineEditBlockId]="block.blockId"
    inlineEditPlaceholder="Insert inspiration intro text"
    [inlineEditMultiline]="true"
    (inlineEditChange)="onChange($event, 'X2ExpParagraph')"
  ></span>

  <div class="cr-xe-grid">
    <div class="cr-xe-item">
      <div
        class="cr-xe-dropzone"
        [appInlineMedia]="block.variables?.['X2Exp1Image']"
        [inlineMediaBlockId]="block.blockId"
        (inlineMediaChange)="onChange($event, 'X2Exp1Image')"
      >
        <a *ngIf="block.variables?.['X2Exp1Image']; else empty1" [href]="card1ImageHref" target="_blank" rel="noopener">
          <img [src]="block.variables?.['X2Exp1Image']" [alt]="block.variables?.['X2Exp1ImageAlt'] || ''" />
        </a>

        <ng-template #empty1>
          <div class="cr-inline-media-icon">
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
              <path d="M12 19.2V11.7" />
              <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
            </svg>
          </div>
          <div class="cr-inline-media-title">Upload image</div>
          <div class="cr-inline-media-subtitle">PNG up to 2 mb</div>
        </ng-template>
      </div>

      <span
        class="cr-xe-heading"
        [appInlineEdit]="block.variables?.X2Exp1Heading ?? ''"
        [inlineEditBlockId]="block.blockId"
        inlineEditPlaceholder="Insert heading"
        (inlineEditChange)="onChange($event, 'X2Exp1Heading')"
      ></span>

      <span
        class="cr-xe-desc"
        [appInlineEdit]="block.variables?.X2Exp1Description ?? ''"
        [inlineEditBlockId]="block.blockId"
        inlineEditPlaceholder="Insert description"
        (inlineEditChange)="onChange($event, 'X2Exp1Description')"
      ></span>

      <a class="cr-xe-cta" [href]="card1CtaHref" target="_blank" rel="noopener">
        <span
          [appInlineEdit]="block.variables?.X2Exp1CtaText ?? ''"
          [inlineEditBlockId]="block.blockId"
          [inlineEditPlaceholder]="ctaButtonPlaceholder"
          (inlineEditChange)="onChange($event, 'X2Exp1CtaText')"
        ></span>
      </a>
    </div>

    <div class="cr-xe-item">
      <div
        class="cr-xe-dropzone"
        [appInlineMedia]="block.variables?.['X2Exp2Image']"
        [inlineMediaBlockId]="block.blockId"
        (inlineMediaChange)="onChange($event, 'X2Exp2Image')"
      >
        <a *ngIf="block.variables?.['X2Exp2Image']; else empty2" [href]="card2ImageHref" target="_blank" rel="noopener">
          <img [src]="block.variables?.['X2Exp2Image']" [alt]="block.variables?.['X2Exp2ImageAlt'] || ''" />
        </a>

        <ng-template #empty2>
          <div class="cr-inline-media-icon">
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
              <path d="M12 19.2V11.7" />
              <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
            </svg>
          </div>
          <div class="cr-inline-media-title">Upload image</div>
          <div class="cr-inline-media-subtitle">PNG up to 2 mb</div>
        </ng-template>
      </div>

      <span
        class="cr-xe-heading"
        [appInlineEdit]="block.variables?.X2Exp2Heading ?? ''"
        [inlineEditBlockId]="block.blockId"
        inlineEditPlaceholder="Insert heading"
        (inlineEditChange)="onChange($event, 'X2Exp2Heading')"
      ></span>

      <span
        class="cr-xe-desc"
        [appInlineEdit]="block.variables?.X2Exp2Description ?? ''"
        [inlineEditBlockId]="block.blockId"
        inlineEditPlaceholder="Insert description"
        (inlineEditChange)="onChange($event, 'X2Exp2Description')"
      ></span>

      <a class="cr-xe-cta" [href]="card2CtaHref" target="_blank" rel="noopener">
        <span
          [appInlineEdit]="block.variables?.X2Exp2CtaText ?? ''"
          [inlineEditBlockId]="block.blockId"
          [inlineEditPlaceholder]="ctaButtonPlaceholder"
          (inlineEditChange)="onChange($event, 'X2Exp2CtaText')"
        ></span>
      </a>
    </div>
  </div>
</div>

<!-- Right panel: real edit form - shared paragraph, then two identical field groups -->
<div class="cr-xe-edit" *ngIf="!isPreview">
  <app-field-editor-v2
    type="content"
    [multiline]="true"
    [showCounter]="true"
    [blockData]="block.variables?.['X2ExpParagraph'] ?? ''"
    (handleOnChange)="onChange($event, 'X2ExpParagraph')"
    [placeholder]="paragraphPlaceholder"
    [maxLength]="4000"
    variable="X2ExpParagraph"
    [disabled]="disabled"
  ></app-field-editor-v2>

  <div class="cr-xe-edit-card">
    <div class="cr-xe-edit-card-title">Card 1</div>

    <div class="cr-xe-field-row">
      <span class="cr-xe-field-label">Image</span>
      <span
        class="cr-xe-toggle"
        [class.cr-xe-toggle-on]="image1AsUpload"
        role="button"
        tabindex="0"
        [title]="image1AsUpload ? 'Switch to entering an image link' : 'Switch to uploading an image'"
        (click)="toggleImage1Mode()"
        (keydown.enter)="toggleImage1Mode()"
        (keydown.space)="toggleImage1Mode()"
      ></span>
    </div>
    <div class="cr-xe-image-field">
      <app-block-text
        [maxLength]="500"
        type="link"
        [blockData]="block.variables?.['X2Exp1Image'] ?? ''"
        (handleOnChange)="onChange($event, 'X2Exp1Image')"
        [placeholder]="image1Placeholder"
        variable="X2Exp1Image"
        [isImage]="image1AsUpload"
        [isPlainText]="true"
        [blockId]="block.blockId"
      ></app-block-text>
      <div class="cr-xe-empty-overlay" *ngIf="image1AsUpload && !block.variables?.['X2Exp1Image']">
        <div class="cr-xe-icon">
          <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
            <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
            <path d="M12 19.2V11.7" />
            <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
          </svg>
        </div>
        <div class="cr-xe-title">Upload image</div>
        <div class="cr-xe-subtitle">PNG up to 2 mb</div>
      </div>
    </div>

    <div class="cr-xe-link-field">
      <app-field-editor-v2
        [maxLength]="500"
        type="action-link"
        [blockData]="block.variables?.['X2Exp1ImageHref'] ?? ''"
        (handleOnChange)="onChange($event, 'X2Exp1ImageHref')"
        [placeholder]="image1HrefPlaceholder"
        variable="X2Exp1ImageHref"
        (handleOnSegmentChange)="handleOnSegmentChange($event, 'X2Exp1ImageHrefSegmentRegex')"
        [selectedSegment]="block.variables?.['X2Exp1ImageHrefSegmentRegex'] ?? ''"
        [disabled]="disabled"
      ></app-field-editor-v2>
    </div>

    <app-field-editor-v2
      type="alt"
      [blockData]="block.variables?.['X2Exp1ImageAlt'] ?? ''"
      (handleOnChange)="onChange($event, 'X2Exp1ImageAlt')"
      [placeholder]="image1AltPlaceholder"
      [maxLength]="500"
      variable="X2Exp1ImageAlt"
      [disabled]="disabled"
    ></app-field-editor-v2>

    <app-field-editor-v2
      type="content"
      [blockData]="block.variables?.['X2Exp1Heading'] ?? ''"
      (handleOnChange)="onChange($event, 'X2Exp1Heading')"
      [placeholder]="heading1Placeholder"
      [maxLength]="500"
      variable="X2Exp1Heading"
      [disabled]="disabled"
    ></app-field-editor-v2>

    <app-field-editor-v2
      type="content"
      [blockData]="block.variables?.['X2Exp1Description'] ?? ''"
      (handleOnChange)="onChange($event, 'X2Exp1Description')"
      [placeholder]="description1Placeholder"
      [maxLength]="500"
      variable="X2Exp1Description"
      [disabled]="disabled"
    ></app-field-editor-v2>

    <div class="cr-xe-link-field">
      <app-field-editor-v2
        type="action-link"
        [blockData]="block.variables?.['X2Exp1CtaLink'] ?? ''"
        (handleOnChange)="onChange($event, 'X2Exp1CtaLink')"
        [placeholder]="ctaLink1Placeholder"
        [maxLength]="500"
        variable="X2Exp1CtaLink"
        (handleOnSegmentChange)="handleOnSegmentChange($event, 'X2Exp1CtaLinkSegmentRegex')"
        [selectedSegment]="block.variables?.['X2Exp1CtaLinkSegmentRegex'] ?? ''"
        [disabled]="disabled"
      ></app-field-editor-v2>
    </div>

    <app-field-editor-v2
      type="content"
      [blockData]="block.variables?.['X2Exp1CtaText'] ?? ''"
      (handleOnChange)="onChange($event, 'X2Exp1CtaText')"
      [placeholder]="ctaText1Placeholder"
      [maxLength]="30"
      variable="X2Exp1CtaText"
      [disabled]="disabled"
    ></app-field-editor-v2>
  </div>

  <div class="cr-xe-edit-card">
    <div class="cr-xe-edit-card-title">Card 2</div>

    <div class="cr-xe-field-row">
      <span class="cr-xe-field-label">Image</span>
      <span
        class="cr-xe-toggle"
        [class.cr-xe-toggle-on]="image2AsUpload"
        role="button"
        tabindex="0"
        [title]="image2AsUpload ? 'Switch to entering an image link' : 'Switch to uploading an image'"
        (click)="toggleImage2Mode()"
        (keydown.enter)="toggleImage2Mode()"
        (keydown.space)="toggleImage2Mode()"
      ></span>
    </div>
    <div class="cr-xe-image-field">
      <app-block-text
        [maxLength]="500"
        type="link"
        [blockData]="block.variables?.['X2Exp2Image'] ?? ''"
        (handleOnChange)="onChange($event, 'X2Exp2Image')"
        [placeholder]="image2Placeholder"
        variable="X2Exp2Image"
        [isImage]="image2AsUpload"
        [isPlainText]="true"
        [blockId]="block.blockId"
      ></app-block-text>
      <div class="cr-xe-empty-overlay" *ngIf="image2AsUpload && !block.variables?.['X2Exp2Image']">
        <div class="cr-xe-icon">
          <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
            <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
            <path d="M12 19.2V11.7" />
            <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
          </svg>
        </div>
        <div class="cr-xe-title">Upload image</div>
        <div class="cr-xe-subtitle">PNG up to 2 mb</div>
      </div>
    </div>

    <div class="cr-xe-link-field">
      <app-field-editor-v2
        [maxLength]="500"
        type="action-link"
        [blockData]="block.variables?.['X2Exp2ImageHref'] ?? ''"
        (handleOnChange)="onChange($event, 'X2Exp2ImageHref')"
        [placeholder]="image2HrefPlaceholder"
        variable="X2Exp2ImageHref"
        (handleOnSegmentChange)="handleOnSegmentChange($event, 'X2Exp2ImageHrefSegmentRegex')"
        [selectedSegment]="block.variables?.['X2Exp2ImageHrefSegmentRegex'] ?? ''"
        [disabled]="disabled"
      ></app-field-editor-v2>
    </div>

    <app-field-editor-v2
      type="alt"
      [blockData]="block.variables?.['X2Exp2ImageAlt'] ?? ''"
      (handleOnChange)="onChange($event, 'X2Exp2ImageAlt')"
      [placeholder]="image2AltPlaceholder"
      [maxLength]="500"
      variable="X2Exp2ImageAlt"
      [disabled]="disabled"
    ></app-field-editor-v2>

    <app-field-editor-v2
      type="content"
      [blockData]="block.variables?.['X2Exp2Heading'] ?? ''"
      (handleOnChange)="onChange($event, 'X2Exp2Heading')"
      [placeholder]="heading2Placeholder"
      [maxLength]="500"
      variable="X2Exp2Heading"
      [disabled]="disabled"
    ></app-field-editor-v2>

    <app-field-editor-v2
      type="content"
      [blockData]="block.variables?.['X2Exp2Description'] ?? ''"
      (handleOnChange)="onChange($event, 'X2Exp2Description')"
      [placeholder]="description2Placeholder"
      [maxLength]="500"
      variable="X2Exp2Description"
      [disabled]="disabled"
    ></app-field-editor-v2>

    <div class="cr-xe-link-field">
      <app-field-editor-v2
        type="action-link"
        [blockData]="block.variables?.['X2Exp2CtaLink'] ?? ''"
        (handleOnChange)="onChange($event, 'X2Exp2CtaLink')"
        [placeholder]="ctaLink2Placeholder"
        [maxLength]="500"
        variable="X2Exp2CtaLink"
        (handleOnSegmentChange)="handleOnSegmentChange($event, 'X2Exp2CtaLinkSegmentRegex')"
        [selectedSegment]="block.variables?.['X2Exp2CtaLinkSegmentRegex'] ?? ''"
        [disabled]="disabled"
      ></app-field-editor-v2>
    </div>

    <app-field-editor-v2
      type="content"
      [blockData]="block.variables?.['X2Exp2CtaText'] ?? ''"
      (handleOnChange)="onChange($event, 'X2Exp2CtaText')"
      [placeholder]="ctaText2Placeholder"
      [maxLength]="30"
      variable="X2Exp2CtaText"
      [disabled]="disabled"
    ></app-field-editor-v2>
  </div>
</div>
